interface IProps {
    color?: string;
    size?: number;
    onClick?: () => void;
    stoke?: string;
}

export const BudgeRightArrow = (props: IProps) => {
    const { stoke } = props;
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.93652 3.26404L8.06352 6.00004"
                stroke={stoke || "white"}
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M4.93652 3.26404L8.06352 6.00004"
                stroke={stoke || "white"}
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.93652 8.736L8.06352 6"
                stroke={stoke || "white"}
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M4.93652 8.736L8.06352 6"
                stroke={stoke || "white"}
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
